import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { grey } from "@mui/material/colors";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";
import { OrganizationVaProfile, VaCollabPreference } from "schemas/dashboard";
import { Map } from "schemas/functions";

import QuestionChip from "features/Influencer/VA/VASettings/QuestionChip";

const styles = {
  circle: {
    border: `1px solid`,
    borderColor: grey[300],
    width: 30,
    height: 30,
    borderRadius: 50,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    color: "green.main",
    fontWeight: 600,
  },
  chip: {
    color: "green.main",
    fontWeight: 600,
    border: `1px solid`,
    borderColor: grey[300],
    px: 2,
    py: 0.5,
    borderRadius: 4,
  },
};

interface Props {
  questionKey: keyof OrganizationVaProfile;
  index: number;
  question: string;
  title: string;
  description: JSX.Element;
  handleSelect: (
    questionKey: keyof OrganizationVaProfile,
    collabPreference: VaCollabPreference,
  ) => void;
  labels: Map;
}

const PreferenceSection = ({
  questionKey,
  index,
  question,
  title,
  description,
  handleSelect,
  labels,
}: Props) => {
  const { organizationVaProfile } = useContext(OrganizationUserContext);

  return (
    <Grid
      sx={{
        my: 3,
        p: 3,
        borderRadius: 3,
        border: "1px solid",
        borderColor: grey[200],
      }}
    >
      <Grid alignItems="center" container gap={0.5} sx={{ mb: 2 }}>
        <Box sx={styles.circle}>{index}</Box>
        <Box sx={styles.chip}>{title}</Box>
      </Grid>

      <Grid>
        <Typography sx={{ fontSize: 16, my: 2 }}>{question}</Typography>
        <Typography component="div">{description}</Typography>
      </Grid>

      <Grid container gap={1} sx={{ mt: 3 }}>
        {[
          VaCollabPreference.all,
          VaCollabPreference.none,
          VaCollabPreference.some,
        ].map((option) => (
          <QuestionChip
            isSelected={
              organizationVaProfile?.[
                questionKey as keyof OrganizationVaProfile
              ] === option
            }
            onClick={() => {
              handleSelect(questionKey, option);
            }}
            key={option}
            label={labels[option]}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default PreferenceSection;
